import React, { useState } from 'react';
import "../css/GuiaUso.css";
import { Button } from '@mui/material';
import imgGuiaSol from "../logos/guia_solicitar.jpg";
import imgGuiaGes from "../logos/guia_gestion.jpg";
import pdfUso from "../Utilidades/GUÍADEUSO.pdf"
// import { Viewer, Worker } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';


function GuiaUso() {

  const [datosTurno, setDatosTurno] = useState({dni: 0, email: ""})
  
  
  return (
    <>
        <p className='lobby-titulo'>Guía de uso</p>
        <br/>
        {/* <div className='explicacion-box'>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
            <Viewer fileUrl={pdfUso} />

          </Worker>
        </div> */}
        <iframe src={pdfUso} style={{"width": "95%", "height":"90vh", "maxWidth": "815px"}}></iframe>
    </>
  );
}

export default GuiaUso;
